import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConstants } from 'src/app/constants/app.constant';
import { environment } from 'src/environments/environment';
import { DataTransferObject } from '../dto/DataTransferObject';
import { HttpHelper } from '../helper/http.Helper';
import { LocalStorage } from '../helper/localStorage';

@Injectable({
  providedIn: 'root',
})
export abstract class BaseService<T extends any> {
  headers = new HttpHeaders();
  private httpHelper: HttpHelper;
  protected localStorage: LocalStorage;

  constructor(
    @Inject(String) public controller: string,
    @Inject(String) private url: any
  ) {
    this.httpHelper = AppConstants.injector.get(HttpHelper);
    this.localStorage = AppConstants.injector.get(LocalStorage);
    const accessToken = this.localStorage.get('accessToken');
    this.headers = this.headers.append('Content-Type', 'application/json');
    this.headers = this.headers.append(
      'Authorization',
      accessToken ? accessToken : 'xxx'
    );
    this.headers = this.headers.append('Access-Control-Allow-Origin', '*');
  }

  async Get(key: any) {
    const dto = await this.get('', key);
    return dto;
  }

  async getAll() {
    const dto = await this.get('/all');
    return dto;
  }

  async save(dto: T) {
    let result;
    if (dto) {
      result = await this.put('', dto);
    } else {
      result = await this.post('', dto);
    }

    return result;
  }

  async delete(Id: any) {
    let dto: any = {
      KeyValue: Id,
      ReturnObject: true,
    };
    const result = await this.del('', dto);
    return result;
  }

  async get(
    method?: any,
    httpParams?: Array<any>,
    queryParams?: any
  ): Promise<DataTransferObject<T>> {
    const url = this.getUrl(method, httpParams);
    const urlWithQueryParams = queryParams ? `${url}?${new URLSearchParams(queryParams).toString()}` : url;
    return await this.httpHelper.get<DataTransferObject<T>>(
      urlWithQueryParams,
      this.headers
    );
  }

  getObservable(
    method?: any,
    httpParams?: Array<any>
  ): Observable<DataTransferObject<T>> {
    return this.httpHelper.getObservable<DataTransferObject<T>>(
      this.getUrl(method, httpParams),
      this.headers
    );
  }

  async post(
    method: string,
    body?: T,
    httpParams?: Array<any>,
    queryParams?: any
  ): Promise<T> {

    return await this.httpHelper.post<T>(
      this.getUrl(method, httpParams),
      this.headers,
      body
    );
  }

  postObservable(
    method: string,
    body?: T,
    httpParams?: Array<any>,
    queryParams?: any
  ): Observable<DataTransferObject<T>> {

    return this.httpHelper.postObservable<DataTransferObject<T>>(
      this.getUrl(method, httpParams),
      this.headers,
      body,
      queryParams,
      'json'
    );

  }

  async put(
    method: string,
    body?: T,
    httpParams?: [any],
    queryParams?: any
  ): Promise<T> {
    return await this.httpHelper.put<T>(
      this.getUrl(method, httpParams),
      this.headers,
      body
    );
  }

  async patch(
    method: string,
    body?: T,
    httpParams?: [any],
    queryParams?: any
  ): Promise<T> {
    return await this.httpHelper.patch<T>(
      this.getUrl(method, httpParams),
      this.headers,
      body
    );
  }
  async del(method: string, httpParams?: [any], queryParams?: any): Promise<T> {
    return await this.httpHelper.delete<T>(
      this.getUrl(method, httpParams),
      this.headers
    );
  }

  private getUrl(method: string, httpParams?: any): string {
    let result: string;

    if (!this.url) {
      this.url = environment.apiUrl;
    }

    result = this.url
      .concat(this.controller)
      .concat(method || '');

    if (httpParams) {
      result = result
        .concat('/')
        .concat(Array.isArray(httpParams) ? httpParams.join('/') : httpParams);
    }

    return result;
  }

  async uploadFile(
    method: string,
    header: HttpHeaders,
    body?: DataTransferObject<T>,
    params?: Array<any>
  ): Promise<DataTransferObject<T>> {
    return await this.httpHelper.post<DataTransferObject<T>>(
      this.getUrl(method, params),
      header,
      body
    );
  }

  downloadFile(
    method: string,
    body?: T,
    httpParams?: Array<any>,
    queryParams?: any
  ): Observable<any> {
    return this.httpHelper.postObservable(
      this.getUrl(method, httpParams),
      this.headers,
      body,
      queryParams,
      'blob'
    );
  }

  setHeaderForImageForPost()
  {
    const accessToken = this.localStorage.get('accessToken');
    let header = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Authorization':accessToken ? accessToken : 'xxx',
    });
    return header;
  }

  setHeaderForImageForBolb()
  {
    const accessToken = this.localStorage.get('accessToken');
    let header = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Authorization':accessToken ? accessToken : 'xxx',
      'Content-Type': 'image/png'
    });
    return header;
  }

  downloadInvoice(
    url: string,
    header: HttpHeaders,
    body?: T,
    httpParams?: Array<any>,
    queryParams?: any
  ): Observable<any> {
    return this.httpHelper.postObservable(
      url,
      header,
      body
    );
  }


}
